import userApiClient from '../../../api/user';
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from '../../../hooks/useKlydoMutation';

const useAddClockToUserMutation = (
  options?: UseKlydoMutationOptions<void, { clockId: string }>,
) => {
  return useKlydoMutation({
    mutationKey: ['add-clock-to-user'],
    mutationFn: ({ clockId }) => userApiClient.addClockToUser(clockId),
    ...options,
  });
};

export default useAddClockToUserMutation;
